import React, { useEffect, useState } from "react";

import {
  Row,
  Input,
  Typography,
  Form,
  Col,
  DatePicker,
  InputNumber,
  Divider,
  Avatar,
  Space,
  Card,
  Spin,
  Modal,
  Tooltip,
  Popover,
} from "antd";
import {
  ArrowDownFromLine,
  ArrowUpFromLine,
  BookUp2,
  CircleAlert,
  Medal,
  Timer,
  UserRound,
} from "lucide-react";
import { FONT } from "constants/index";
import {
  ColumnsUserComparation,
  ColumnsUserComparationAqua,
} from "./columns-table";
import { chartBar, chartLiner } from "./reviews-drawer-charts";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DrawerApp from "components/drawer-app";
import FormNewUserReview from "./reviews-drawer-new-review";
import {
  getReviewUserById,
  putReview,
  deleteReview,
} from "services/review/review-service";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import moment from "moment";
import FormNewUserReviewAqua from "./reviews-drawer-new-review-aqua";
import useBreakpoint from "hooks/useBreakpoint";
import ResponsiveDataList from "components/responsive-data-list";
dayjs.extend(customParseFormat);
const { Text } = Typography;
const dateFormat = "DD/MM/YYYY";
const { confirm } = Modal;
const FormUserComparationAqua = (props) => {
  const { isMobile, isDesktop, width } = useBreakpoint();
  const [data, setDataDrawer] = useState({ reviews: [] });
  const [imgAvatar, setImgAvatar] = useState(null);
  const formRefComp = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editRow, setEditRow] = useState(null);

  useEffect(() => {
    const data = props.dataDrawer;
    data.reviews = data?.reviews?.map((obj) => ({
      ...obj,
      changeActualComp: changeActual,
      changeLastComp: changeLast,
      showDrawer: showDrawer,
      delete: deleteReviewItem,
    }));
    setDataDrawer(data);

    setImgAvatar(props.imgAvatar);
    formRefComp.current?.setFieldsValue({
      name: props.dataDrawer.name,
      reviewActual: props.dataDrawer?.actualReview?.reviewDate
        ? dayjs(props.dataDrawer?.actualReview?.reviewDate)
        : null,
      reviewComparation: props.dataDrawer?.lastReview?.reviewDate
        ? dayjs(props.dataDrawer?.lastReview?.reviewDate)
        : null,
      loadActual: props.dataDrawer?.actualReview?.load1,
      loadComparation: props.dataDrawer?.lastReview?.load1,
      vmpActual: props.dataDrawer?.actualReview?.vmp1,
      vmpComparation: props.dataDrawer?.lastReview?.vmp1,
    });
  }, [props, setLoading]);

  const changeActual = function (row, data) {
    setLoading(true);
    setTimeout(() => {
      data.actualReview = row;
      formRefComp.current?.setFieldsValue({
        reviewActual: row.reviewDate ? dayjs(row.reviewDate) : null,
        loadActual: row.load1,
        vmpActual: row.vmp1,
      });
      setDataDrawer(data);
      setLoading(false);
    }, 300);
  };

  const changeLast = function (row, data) {
    setLoading(true);
    setTimeout(() => {
      data.lastReview = row;
      formRefComp.current?.setFieldsValue({
        reviewComparation: row.reviewDate ? dayjs(row.reviewDate) : null,
        loadComparation: row.load1,
        vmpComparation: row.vmp1,
      });

      setDataDrawer(data);
      setLoading(false);
    }, 300);
  };
  const showDrawer = (row) => {
    setEditId(row.id);
    setEditRow(row);
    setOpen(true);
  };
  const onClose = () => {
    setEditId(null);
    setEditRow(null);
    setOpen(false);
  };
  function getData() {
    getReviewUserById(props.dataDrawer.id)
      .then((res) => {
        res.reviews = res?.reviews?.map((obj) => ({
          ...obj,
          changeActualComp: changeActual,
          changeLastComp: changeLast,
          showDrawer: showDrawer,
          delete: deleteReviewItem,
        }));
        setDataDrawer(res);
        formRefComp.current?.setFieldsValue({
          name: res.name,
          reviewActual: res.actualReview?.reviewDate
            ? dayjs(res.actualReview?.reviewDate)
            : null,
          reviewComparation: res.lastReview?.reviewDate
            ? dayjs(res.lastReview?.reviewDate)
            : null,
          loadActual: res?.actualReview?.load1,
          loadComparation: res?.lastReview?.load1,
          vmpActual: res?.actualReview?.vmp1,
          vmpComparation: res?.lastReview?.vmp1,
        });
        setLoading(false);
        notificationSucess();
        onClose();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function deleteReviewItem(row) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Tem certeza que deseja deletar a avaliação do dia '
            {moment(row.reviewDate).format("DD/MM/YYYY")}' ?
          </span>
        </div>
      ),
      icon: null,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoading(true);
        deleteReview(row.id)
          .then(() => {
            getData();
          })
          .catch((err) => {
            setLoading(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  return (
    <>
      <Spin size="large" spinning={loading}>
        <Form ref={formRefComp} layout="vertical" className="reviews-comparation-form">
          <Row
            gutter={16}
            style={{ textAlign: "center", marginBottom: "30px" }}
          >
            <Col span={24}>
              <Avatar
                src={imgAvatar}
                icon={<UserRound size={120} />}
                size={120}
              />
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: "15px" }}>
            <Col span={24}>
              <Card
                id="card-table"
                className="card-table-list"
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <Medal
                        size={18}
                        style={{ marginBottom: "-4px", marginRight: "10px" }}
                      />
                      <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                        Histórico de Avaliações
                      </Text>
                    </div>
                  </div>
                }
                bordered={false}
              >
                <ResponsiveDataList
                  isMobile={isMobile}
                  forceCardLayout={!isDesktop}
                  cardVariant={!isDesktop ? "history" : undefined}
                  rowKey="id"
                  columns={ColumnsUserComparationAqua(data)}
                  dataSource={data.reviews}
                  pagination={{ pageSize: 2, showSizeChanger: false }}
                  locale={{
                    emptyText: "Sem registro",
                  }}
                />
              </Card>
            </Col>
          </Row>
          <Divider />

          <Row gutter={16} style={{ marginTop: "15px" }}>
            <Col
              xs={24} lg={12}
              style={{ marginTop: "10px" }}
            >
              <Form.Item
                name="name"
                label={<span style={{ fontFamily: FONT }}>Aluno</span>}
              >
                <Input
                  disabled={true}
                  style={{ fontFamily: FONT }}
                  defaultValue={data.name}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={6} style={{ marginTop: "10px" }}>
              <Form.Item
                name="reviewActual"
                label={
                  <span style={{ fontFamily: FONT }}>Avaliação Atual</span>
                }
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a data da avaliação",
                  },
                ]}
              >
                <DatePicker
                  style={{ fontFamily: FONT, width: "100%" }}
                  format={dateFormat}
                  suffixIcon={null}
                  placeholder={""}
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={6} style={{ marginTop: "10px" }}>
              <Form.Item
                name="reviewComparation"
                label={
                  <span style={{ fontFamily: FONT }}>
                    Avaliação de Comparação
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a data da avaliação",
                  },
                ]}
              >
                <DatePicker
                  style={{ fontFamily: FONT, width: "100%" }}
                  placeholder={""}
                  format={dateFormat}
                  suffixIcon={null}
                  disabled={true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col
              xs={24} lg={12}
              style={{ marginTop: "10px" }}
            >
              <Form.Item
                name="loadActual"
                label={<span style={{ fontFamily: FONT }}>Tempo Atual</span>}
              >
                <InputNumber
                  disabled={true}
                  decimalSeparator=","
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24} lg={12}
              style={{ marginTop: "10px" }}
            >
              <Form.Item
                name="loadComparation"
                label={
                  <span style={{ fontFamily: FONT }}>Tempo Comparação</span>
                }
              >
                <InputNumber
                  disabled={true}
                  decimalSeparator=","
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col
              xs={24} lg={12}
              style={{ marginTop: "10px" }}
            >
              <Form.Item
                name="vmpActual"
                label={<span style={{ fontFamily: FONT }}>Média Atual</span>}
              >
                <InputNumber
                  disabled={true}
                  decimalSeparator=","
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24} lg={12}
              style={{ marginTop: "10px" }}
            >
              <Form.Item
                name="vmpComparation"
                label={
                  <span style={{ fontFamily: FONT }}>Média Comparação</span>
                }
              >
                <InputNumber
                  disabled={true}
                  decimalSeparator=","
                  style={{ fontFamily: FONT, width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={16} style={{ marginTop: "15px" }}>
          <Col span={24} style={{ marginTop: "10px" }}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Timer
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: FONT }}>
                      Tempo
                    </Text>
                  </div>
                </div>
              }
              style={{ width: "100%" }}
            >
              {chartBar(
                [
                  { load: null, loadActual: null, loadComparation: null },

                  {
                    load: null,
                    loadActual: data?.actualReview?.load1,
                    loadComparation: data?.lastReview?.load1,
                  },

                  { load: null, loadActual: null, loadComparation: null },
                ],
                "load",
                "loadActual",
                "loadComparation",
                "Tempo Atual",
                "Tempo Comparação",
                10
              )}
            </Card>
          </Col>
        </Row>
        <DrawerApp
          open={open}
          onClose={onClose}
          title={"Editar Avaliação"}
          body={
            <FormNewUserReviewAqua
              user={{
                id: props.dataDrawer.id,
                img: props.dataDrawer.img,
                name: props.dataDrawer.name,
              }}
              editId={editId}
              onClose={onClose}
              getData={getData}
              editRow={editRow}
            />
          }
          size={"large"}
          isOnlyView={true}
        />
      </Spin>
    </>
  );
};
export default FormUserComparationAqua;
